// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__PoyBx","list":"styles_list__1jiSP"};